import { AxiosInstance } from 'axios';
import * as Sentry from '@sentry/react';
import { config } from 'config';
import { RegistrationType, VehicleType } from 'types';
import { AxiosClient, AxiosUtils } from '../AxiosClient/AxiosClient';

export type ValidateImmatResponse = {
  immat: string;
  vin: string;
  immatOrigin: RegistrationType;
  ngcData: boolean;
  vehicleType: VehicleType;
  ngcDown?: boolean;
};

class ValidImmat {
  private readonly client: AxiosInstance;

  constructor() {
    this.client = AxiosClient.get({
      baseURL: config.URL_VALID_IMMAT,
      xClientSource: false,
    });
  }

  async validate(data: { registration?: string; vin?: string; isPro: boolean }): Promise<ValidateImmatResponse> {
    const { registration, vin, isPro } = data;
    return this.client
      .get<any>('immat-status', {
        params: {
          immat: registration,
          vin,
          sellerType: isPro ? 'PRO' : 'PART',
        },
      })
      .then(result => {
        const data = result.data;

        if (data.vehicleType === 'UTIL') {
          data.vehicleType = 'UTILITAIRE';
        } else if (data.vehicleType === 'CAMPING_CAR') {
          data.vehicleType = 'CAMPING-CAR';
        }

        if (!['AUTO', 'MOTO', 'UTILITAIRE', 'CAMPING-CAR', 'CARAVANE'].includes(data.vehicleType)) {
          data.vehicleType = 'UNKNOWN';
        }
        return data;
      })
      .catch(r => {
        // Passage en mode débrayé
        Sentry.captureException(r, {
          tags: {
            api: 'Matching-immat',
            endpoint: 'immat-status',
            ...AxiosUtils.enrichTags(r),
          },
        });
        return {
          immat: registration,
          vin,
          immatOrigin: '',
          ngcData: true,
          vehicleType: 'UNKNOWN',
          ngcDown: true,
        };
      });
  }
}

export const ValidImmatService = new ValidImmat();
